import React from 'react'
import welcomeStyle from './WelcomeAuthormeetPage.module.css'
import { Link } from 'react-router-dom';
import MainHeader from '../../components/mainheader/MainHeader'
import { useMediaQuery } from 'react-responsive';

export default function WelcomeAuthormeetPage() {

    const isMobile = useMediaQuery({ query: '(max-width: 768px)' });

    return (
        <>
            <MainHeader />
            {isMobile ? (
                <div className={`${welcomeStyle.mobilwelcomepage}`}>
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h3>Welcome to AuthorMeet</h3>
                                <p>How would you like to sign up as?</p>
                            </div>
                            <div className="col-md-12">
                                {/* <button className={`${welcomeStyle.welcomeButtonone} btn btn-warning w-100 mb-3`}> Are you a Parent? </button> */}
                                <button className={`${welcomeStyle.welcomeButtontwo} btn btn-warning w-100 mb-3`}> Are you an event host or coordinator? </button>
                                <button className={`${welcomeStyle.welcomeButtonthree} btn btn-warning w-100 mb-3`}> Are you an Author/Illustrator? </button>
                                {/* <button className={`${welcomeStyle.welcomeButtonfour} btn btn-warning w-100`}> Are you a Publisher? </button> */}
                            </div>
                            <div className={`${welcomeStyle.newAccountwelcomepage} text-center pb-4`}>
                                <p className='mb-0'> Already have an account?
                                    <Link to="/general-login" className={`${welcomeStyle.welcomepageAchor}`}> Log in </Link>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            ) : (
                <div className={`${welcomeStyle.welcomeauthormeetpage} h-100 mt-5`}>
                    <div className="container h-100">
                        <div className="row justify-content-center h-100 align-items-center">
                            <div className="col-md-8">
                                <div className={welcomeStyle.welcomeContent}>
                                    <div className="row justify-content-center">
                                        <div className="col-xl-6">
                                            <div className={`${welcomeStyle.welcomeauthormeetmainContent} text-center`}>
                                                <h2> Welcome to AuthorMeet </h2>
                                                <p className={`${welcomeStyle.welcomeSubtitle}`}> How would you like to sign up as? </p>
                                                <div className='d-flex align-items-center flex-column'>
                                                    {/* <button className={`${welcomeStyle.welcomeButtonone} btn btn-warning w-100 mb-3`}> <Link to="/ParentsRegisterPage" > Are you a Parent? </Link></button> */}
                                                    <button className={`${welcomeStyle.welcomeButtontwo} btn btn-warning w-100 mb-3`}><Link to="/coordinator-register" > Are you an event host or coordinator? </Link></button>
                                                    <button className={`${welcomeStyle.welcomeButtonthree} btn btn-warning w-100 mb-3`}><Link to="/AuthorRagistrationPage" > Are you an Author/Illustrator? </Link></button>
                                                    {/* <button className={`${welcomeStyle.welcomeButtonfour} btn btn-warning w-100`}><Link to="/PublishersRegisterPage" > Are you a Publisher? </Link></button> */}
                                                </div>
                                                <div className={`${welcomeStyle.newAccountwelcomepage}`}>
                                                    <p className='mb-0'> Already have an account?
                                                        <Link to="/general-login" className={`${welcomeStyle.welcomepageAchor}`}> Log in </Link>
                                                    </p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            )}
        </>
    )
}